import { httpClient } from '@/services/http/httpClient'

export async function readAllUserNotifications(): Promise<void> {
  await httpClient.patch(`/events/v2`)
}
